import {initialState} from "../initialState";
import {
    CHANGE_PASSWORD_SUCCESS,
    CHECK_TOKEN_BEGAN, CHECK_TOKEN_FAILED, CHECK_TOKEN_REJECTED, CHECK_TOKEN_SUCCESS,
    DISCONNECT,
    LOGIN_BEGAN, LOGIN_FAILED, LOGIN_REJECTED,
    LOGIN_SUCCESS,
    REGISTER_BEGAN,
    REGISTER_FAILED,
    REGISTER_REJECTED,
    REGISTER_SUCCESS, SAVE_FIREBASE_TOKEN,
} from "../actionTypes/auth";


const authReducer = (state = initialState.auth, action) => {
    switch (action.type) {
        case REGISTER_BEGAN:
            return {
                ...state,
                fetching: true,
                user: null,
                rejectedError: null,
                failedError: null,
                connected: false
            }

        case REGISTER_SUCCESS:
            return {
                ...state,
                fetching: false,
                user: action.payload.user,
                token: action.payload.token,
                connected: true
            }

        case REGISTER_REJECTED:
            return {
                ...state,
                fetching: false,
                rejectedError: action.payload,
                connected: false
            }

        case REGISTER_FAILED:
            return {
                ...state,
                fetching: false,
                failedError: action.payload,
                connected: false
            }

        case LOGIN_BEGAN:
            return {
                ...state,
                fetching: true,
                user: null,
                rejectedError: null,
                failedError: null,
                connected: false
            }

        case LOGIN_SUCCESS:
            return {
                ...state,
                fetching: false,
                user: action.payload.user,
                token: action.payload.token,
                connected: true
            }

        case LOGIN_REJECTED:
            return {
                ...state,
                fetching: false,
                rejectedError: action.payload,
                connected: false
            }

        case LOGIN_FAILED:
            return {
                ...state,
                fetching: false,
                failedError: action.payload,
                connected: false
            }
        case CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                fetching: false,
                user: action.payload.user,
                token: action.payload.token,
                connected: true
            }
        case CHECK_TOKEN_BEGAN:
            return {
                ...state,
                fetching: true,
                rejectedError: null,
                failedError: null
            }

        case CHECK_TOKEN_SUCCESS:
            return {
                ...state,
                fetching: false,
                user: action.payload.user,
                token: action.payload.token,
                connected: true
            }

        case CHECK_TOKEN_REJECTED:
            return {
                ...state,
                fetching: false,
                connected: false,
                tokenRejectedError: action.payload
            }

        case CHECK_TOKEN_FAILED:
            return {
                ...state,
                fetching: false,
                connected: false,
                tokenFailedError: action.payload
            }

        case DISCONNECT:
            return {
                ...state,
                fetching: false,
                user: null,
                connected: false,
                rejectedError: null,
                failedError: null
            }

        case SAVE_FIREBASE_TOKEN:
            return {
                ...state,
                firebaseToken: action.payload
            }

        default:
            return state
    }
}

export default authReducer


// SELECTORS

export const fetchingSelector = state => state.auth.fetching
export const connectedSelector = state => state.auth.connected
export const tokenSelector = state => state.auth.token
export const rejectedErrorSelector = state => state.auth.rejectedError
export const failedErrorSelector = state => state.auth.failedError

export const userIdSelector = state => state.auth.user.id
export const userSelector = state => state.auth.user
export const firebaseTokenSelector = state => state.auth.firebaseToken